import { Link, useParams } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";
import { Seo, Reveal } from "../components/Seo";
import { CtaBand } from "../components/blocks";
import { INSIGHTS } from "../lib/site";
import NotFound from "./NotFound";

export default function InsightArticle() {
  const { slug } = useParams();
  const a = INSIGHTS.find((x) => x.slug === slug);
  if (!a) return <NotFound />;

  const date = new Date(a.date);
  const dateStr = date.toLocaleDateString("en-NG", { year: "numeric", month: "long", day: "numeric" });

  return (
    <>
      <Seo title={`${a.title} — Softline Nigeria Insights`} description={a.excerpt} path={`/insights/${a.slug}`} type="article" />
      <section className="bg-charcoal noise-bg pt-36 pb-14 md:pt-44 md:pb-20" data-testid="insight-hero">
        <div className="shell">
          <Link to="/insights" data-testid="insight-back-link" className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-softgrey hover:text-lime transition-colors duration-200">
            <ArrowLeft size={14} /> All insights
          </Link>
          <Reveal y={14}>
            <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-lime">
              {a.category} · Draft
            </p>
            <h1 className="font-display font-bold tracking-tight text-white text-3xl sm:text-5xl leading-[1.08] mt-5 max-w-4xl">
              {a.title}
            </h1>
            <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-softgrey/70">
              {dateStr} · {a.readTime} · Draft placeholder pending editorial review
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white" data-testid="insight-body">
        <div className="shell py-20 md:py-24">
          <Reveal>
            <div className="max-w-3xl">
              <div className="border border-lime bg-lime/10 p-5 flex items-start gap-3" data-testid="insight-draft-banner">
                <FileText size={18} className="text-charcoal mt-0.5 shrink-0" aria-hidden="true" />
                <p className="text-sm text-charcoal/80">
                  <span className="font-semibold">Placeholder draft.</span> This article was prepared as draft content for
                  review. It will be edited, approved and re-dated by the content owners before publication.
                </p>
              </div>
              <p className="mt-10 text-lg md:text-xl leading-relaxed text-charcoal/85 font-medium">{a.excerpt}</p>
              <div className="mt-8 space-y-6">
                {a.body.map((para, i) => (
                  <p key={i} className="text-[16px] md:text-[17px] leading-relaxed text-charcoal/75">
                    {para}
                  </p>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
